import { render, staticRenderFns } from "./AboutContactSection.vue?vue&type=template&id=193ba979&scoped=true"
import script from "./AboutContactSection.vue?vue&type=script&lang=js"
export * from "./AboutContactSection.vue?vue&type=script&lang=js"
import style0 from "./AboutContactSection.vue?vue&type=style&index=0&id=193ba979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ba979",
  null
  
)

export default component.exports